export default "/images/logo-19.png?bb31a3a27727a8fb62cb199a84628a89";